import { useQuery } from 'react-query';

import { Announcement } from '../../../types/Announcement';
import Api from '../../api/api';

export const getAnnouncement = async (id: string): Promise<Announcement> => {
  const [response, bodyOrError] = await Api.get(`announcement/${id}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetAnnouncement = (id: string) =>
  useQuery(['getAnnouncement', id], () => getAnnouncement(id), {
    enabled: !!id,
  });
